import { stringifyEntityRef } from '@backstage/catalog-model';
import { compatWrapper } from '@backstage/core-compat-api';
import { useRouteRef } from '@backstage/core-plugin-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { catalogGraphRouteRef } from '@backstage/plugin-catalog-graph';
import { useEntity } from '@backstage/plugin-catalog-react';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { Navigate } from 'react-router-dom';

function RedirectToCatalogGraph() {
  const { entity } = useEntity();
  const catalogGraphRoute = useRouteRef(catalogGraphRouteRef);
  const entityRef = stringifyEntityRef(entity);
  return (
    <Navigate
      to={`${catalogGraphRoute()}?rootEntityRefs[]=${encodeURIComponent(entityRef)}&maxDepth=1`}
      replace
    />
  );
}

/**
 * Component relations content tab — redirects to the full catalog graph
 * page with the current entity pre-selected.
 */
const componentRelationsContent = EntityContentBlueprint.make({
  name: 'component-diagram',
  params: {
    path: '/relations',
    title: 'Relations',
    group: 'development',
    filter: {
      kind: 'component',
      'spec.type': { $in: ['service', 'website', 'library'] },
    },
    loader: async () => compatWrapper(<RedirectToCatalogGraph />),
  },
});

/**
 * System relations content tab — redirects to the full catalog graph
 * page with the current entity pre-selected.
 */
const systemRelationsContent = EntityContentBlueprint.make({
  name: 'system-diagram',
  params: {
    path: '/relations',
    title: 'Relations',
    group: 'overview',
    filter: { kind: 'system' },
    loader: async () => compatWrapper(<RedirectToCatalogGraph />),
  },
});

/**
 * Domain relations content tab — redirects to the full catalog graph
 * page with the current entity pre-selected.
 */
const domainRelationsContent = EntityContentBlueprint.make({
  name: 'domain-diagram',
  params: {
    path: '/relations',
    title: 'Relations',
    group: 'overview',
    filter: { kind: 'domain' },
    loader: async () => compatWrapper(<RedirectToCatalogGraph />),
  },
});

export const relationsRedirectModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    componentRelationsContent,
    systemRelationsContent,
    domainRelationsContent,
  ],
});
